import { IonFooter, IonTitle, IonToolbar } from '@ionic/react'
import React from 'react'
import styled from 'styled-components'

type Size = number | string
export interface FooterProps {
  width?: Size
  height?: Size
  zIndex?: number
  title?: string
}

const StyledToolBar = styled(IonToolbar)`
  --background: #303030;
  background: #303030;
  box-shadow: none;
  border-top: 1px solid #4a4a4a;
`

const StyledIonTitle = styled(IonTitle)`
  text-align: center;
  font-family: 'Montserrat', 'SF Pro Display';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 150%;
`

const StyledFooter = styled(IonFooter)`
  .header-md::after {
    background-image: none;
  }
`

export const Footer = ({ width = '100%', height = '96px', zIndex = 999 }: FooterProps) => {
  return (
    <StyledFooter className="ion-no-border" style={{ width, height, zIndex }}>
      <StyledToolBar style={{ width, height }}>
        <StyledIonTitle style={{ height }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '4px'
            }}
          >
            <div
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '12px',
                fontWeight: 600,
                letterSpacing: '0.15em',
                color: 'rgba(255,255,255,0.85)',
                textTransform: 'uppercase'
              }}
            >
              CONNECT VIEW
            </div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.05em' }}>
              Copyright © Connect co., ltd. All rights reserved.
            </div>
          </div>
        </StyledIonTitle>
      </StyledToolBar>
    </StyledFooter>
  )
}
